import { render, staticRenderFns } from "./DashboardOrders.vue?vue&type=template&id=604dd39a"
import script from "./DashboardOrders.vue?vue&type=script&lang=js"
export * from "./DashboardOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports